import React from "react";
import "./Modal.css";

function Modal({ show, setShow, content }) {
  return (
    <section
      className="modal-container"
      style={{ display: show ? "flex" : "none" }}
    >
      <div className="modal">
        <p className="close" onClick={() => setShow(false)}>
          x
        </p>
        <div>
          <h1>{content.title}</h1>
          {content.available}
        </div>
        {content.content}
      </div>
    </section>
  );
}

export default Modal;
